import { ReactElement, Suspense } from 'react';
import './assets/styles/App.scss';
import { useRoutes } from 'react-router-dom';
import routeElements from './routes/Routes';
import { ThemeProvider } from '@mui/material/styles';
import { LinearProgress } from '@mui/material';
import 'react-toastify/dist/ReactToastify.css';
import themeBuilder from './assets/styles/theme';
import { useSelector } from 'react-redux';
import { DefaultTheme } from 'state/baseapplication/Reducer';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { ToastContainer } from 'react-toastify';

const App = (): ReactElement => {
  const isUserLoggedIn = useSelector(
    (state: any) => state.authState.isUserLoggedIn
  );
  const isOrgSelected = useSelector(
    (state: any) => state.authState.isOrgSelected
  );
  const routes: any = useRoutes(
    // eslint-disable-next-line no-underscore-dangle
    routeElements(isUserLoggedIn, isOrgSelected)
  );

  const themeConfig = useSelector((state: any) => {
    const { theme } = state.baseAppState;
    const pattern = /^#[0-9A-F]{6,}$/i;
    if (!pattern.test(theme.primary)) {
      theme.primary = DefaultTheme.primary;
    }
    if (!pattern.test(theme.primaryContrast)) {
      theme.primaryContrast = DefaultTheme.primaryContrast;
    }
    if (!pattern.test(theme.textPrimary)) {
      theme.textPrimary = DefaultTheme.textPrimary;
    }
    return theme;
  });

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <ThemeProvider theme={themeBuilder(themeConfig)}>
        <ToastContainer autoClose={5000} closeOnClick />
        <Suspense fallback={<LinearProgress color="primary" />}>
          {routes}
        </Suspense>
      </ThemeProvider>
    </LocalizationProvider>
  );
};
export default App;
